import Formsy from 'formsy-react'

import cn from 'classnames'

import Select from '@components/Select/RequiredSelectWithFormsy'
import FormsyInput from '@components/Textfield/withFormsy'
import Button from '@components/Button'
import ErrorMessage from '@components/ErrorMessage'

import { getYearsSelection, getMonthsSelection } from '../../utils'
import { useConfirm } from 'shared/hooks/useConfirm'
import isMobile from 'shared/responsive-helpers'
import useRequestPending from 'shared/hooks/useRequestPending'
import CreditCardFormComponent from 'credit-cards/pagseguro/components/CreditCardFormComponent'
import styles from './styles.module.scss'

const creditCardInputHelper = value =>
    value
        .replace(/\W/gi, '')
        .replace(/(.{4})/g, '$1 ')
        .trim()

const CreditCardForm = ({ onSubmit, zip, pending, translate: t, successCallback, shouldShowInfo = true }) => {
    const formRef = React.useRef(null)
    const { confirm, ConfirmModal } = useConfirm()
    const { isLoading, error } = useRequestPending(pending, () => {
        formRef && formRef.current.reset()
        if (successCallback) successCallback()
    })

    const buttonClassName = cn(
        {
            'mb-5': zip,
        },
        styles.addCardBtn
    )

    const submit = async model => {
        if (shouldShowInfo) {
            const isConfirmed = await confirm()
            if (!isConfirmed) {
                return
            }
        }

        const { cardholdersName, cardNumber, expiryMonth, expiryYear, zipCode } = model
        onSubmit(cardholdersName, cardNumber, expiryMonth, expiryYear, zip ? zip : zipCode)
    }

    return (
        <>
            <ConfirmModal title="credit.card.confirm.title" text="credit.card.confirm.text" />
            <CreditCardFormComponent
                submit={submit}
                formRef={formRef}
                creditCardInputHelper={creditCardInputHelper}
                zip={zip}
                isLoading={isLoading}
                error={error}
                buttonClassName={buttonClassName}
            />
        </>
    )
}

export default withTranslate(CreditCardForm)
